export const boxShadows = {
  default: `0px 1px 1px rgba(20, 20, 20, 0.2)`,
  defaultPrimary: '0px 1px 1px rgba(33, 166, 150, 0.33)',
  hover: `0px 8px 8px rgba(20, 20, 20, 0.2)`,
  hoverPrimary: `0px 8px 8px rgba(33, 166, 150, 0.4)`,
}
